<template>
  <div class="grid h-[40vh] grid-cols-2 gap-7 overflow-auto">
    <button
      v-for="option in dynamicDateOptions"
      :key="option.label"
      class="rounded-sm border px-16 py-6 text-center text-xs font-semibold"
      :class="
        selectedDynamicDate === option.value
          ? 'selected-date-picker-button'
          : 'date-picker-button'
      "
      @click="selectedDynamicDate = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>
<script setup lang="ts">
import { type PropType, computed } from "vue";

import type { DynamicDateOption } from "@/models/datePicker";

const props = defineProps({
  modelValue: {
    type: String,
    default: null,
  },
  dynamicDateOptions: {
    type: Array as PropType<DynamicDateOption[]>,
    required: true,
  },
});

const emit = defineEmits<{
  "update:modelValue": [dynamicDate: string];
}>();

const selectedDynamicDate = computed({
  get() {
    return props.modelValue;
  },
  set(dynamicDate: string) {
    emit("update:modelValue", dynamicDate);
  },
});
</script>
